import React, { useContext, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AuthContext } from "../auth/AuthContext";
import { useForm } from "../hooks/useForm";
import { propsToast } from "../config/toastConfig";
import "../css/LoginPage.css";
import wall from "../assets/images/login2.jpg";
import logo from "../assets/images/logo-light.png";
const baseUrl = process.env.REACT_APP_API;

export const LoginPage = () => {
  const { login } = useContext(AuthContext);
  const [values, handleInputChange, setFormValue] = useForm({
    user: "",
    password: "",
    rememberme: false,
  });
  const [theme, setTheme] = useState({
    nombre: "Runtime Telecom  SA DE CV",
    address: "Aquiles Serdan #180 Col. Centro, Maravatio, Michoacan",

    titulo_portal: "Mi portal",
    imagen_portal: wall,
    logo: "",
  });

  useEffect(() => {
    setUser();
  }, []);

  const setUser = () => {
    const user = localStorage.getItem("user");
    user && setFormValue((values) => ({ ...values, user, rememberme: true }));
  };

  const toggleCheck = () => {
    setFormValue({
      ...values,
      rememberme: !values.rememberme,
    });
  };

  const onSubmit = async (ev) => {
    ev.preventDefault();

    values.rememberme
      ? localStorage.setItem("user", values.user)
      : localStorage.removeItem("user");

    const { user, password } = values;

    const ok = await login(user, password);

    if (!ok)
      toast.error("Error, verifica que tus datos sean correctos!", propsToast);
  };

  const todoOk = () => values.user.length > 0 && values.password.length > 0;

  return (
    <div
      className="flex-container login-cover"
      style={{
        backgroundImage: `url(${theme.imagen_portal})`,
      }}
    >
      <div
        className="d-block p-4 rounded shadow-lg mx-auto text-center"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.6)", // blanco semi-transparente
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.4)", // sombra con más contraste
        }}
      >
        <form onSubmit={onSubmit}>
          {" "}
          <img
            src={logo}
            alt="RTW"
            style={{ width: "300px" }}
            className="rounded mx-auto d-block "
          />
          {/* Email input */}
          <div className="form-outline mb-4">
            <label className="form-label text-dark fw-bolder" htmlFor="form2Example1">
              Usuario
            </label>{" "}
            <input
              type="text"
              id="form2Example1"
              placeholder="Usuario"
              name="user"
              value={values.user}
              onChange={handleInputChange}
              className="form-control"
            />
          </div>
          {/* Password input */}
          <div className="form-outline mb-4">
            <label className="form-label text-dark fw-bolder sfs-2" htmlFor="form2Example2">
              Contraseña
            </label>{" "}
            <input
              type="password"
              id="form2Example2"
              value={values.password}
              onChange={handleInputChange}
              name="password"
              className="form-control"
            />
          </div>
          {/* 2 column grid layout for inline styling */}
          <div className="row mb-4">
            <div className="col d-flex justify-content-center">
              {/* Checkbox */}
              <div className="form-check">
                <input
                  onClick={() => toggleCheck()}
                  className="form-check-input"
                  type="checkbox"
                  name="rememberme"
                  checked={values.rememberme}
                  id="form2Example31"
                />
                <label
                  className="form-check-label text-dark fw-bolder"
                  htmlFor="form2Example31"
                >
                  Recordar
                </label>
              </div>
            </div>
          </div>
          {/* Submit button */}
          <button
            type="submit"
            disabled={!todoOk()}
            className="btn btn-primary btn-block mb-4"
          >
            Ingresar
          </button>
        </form>{" "}
        <ToastContainer />
      </div>
    </div>
  );
};
